import { useMemo } from 'react';
import { Tag } from 'antd';
import { 
  CheckCircleOutlined, 
  StopOutlined, 
  DeleteOutlined
} from '@ant-design/icons';

export const useOrganizationStatusRender = () => {
  return useMemo(() => {
    return (status: string) => {
      const statusConfigs: {
        [key: string]: { color: string; icon: React.ReactNode; text: string };
      } = {
        ACTIVE: { color: 'success', icon: <CheckCircleOutlined />, text: 'Active' },
        INACTIVE: { color: 'default', icon: <StopOutlined />, text: 'Inactive' },
        DELETED: { color: 'error', icon: <DeleteOutlined />, text: 'Deleted' },
      };

      const config = statusConfigs[status] || { color: 'default', icon: <StopOutlined />, text: status };
      
      return (
        <Tag color={config.color} icon={config.icon}>
          {config.text}
        </Tag>
      );
    };
  }, []);
};